<template>
  <b-navbar
    type="light"
    toggleable="xl"
    fixed="top"
    v-b-scrollspy:nav-scroller
    class="header-area"
    :class="{ 'is-sticky': scrolled }"
  >
    <div class="container-fluid container-fluid--cp-150">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand class="navbar-brand" to="/">
        <img src="../assets/img_design/img/pc/CreisLogo_newS2.png" alt="logo"/>
      </b-navbar-brand>
      <b-btn-group class="header-config-wrapper">
        <ul class="list-unstyled topnav-menu float-right mb-0">
          <li class="dropdown d-none d-lg-inline-block topbar-dropdown">
            <a
              class="
                nav-link
                dropdown-toggle
                arrow-none
                waves-effect waves-light
              "
              @click="showlan = 1"
              href="javascript:void(0)"
              role="button"
              aria-haspopup="false"
              aria-expanded="false"
            >
              <img
                :src="
                  cur_lan == 'en'
                    ? '../assets/images/flags/us.jpg'
                    : '../assets/images/flags/japan.jpg'
                "
                alt="user-image"
                height="16"
              />
            </a>
            <div class="dropdown-menu dropdown-menu-left" v-show="showlan == 1">
              <a
                href="javascript:void(0);"
                class="dropdown-item"
                @click="change_language('en')"
              >
                <span class="align-middle" style="line-height: 200%"
                  >English</span
                >
                <img
                  :src="'../assets/images/flags/us.jpg'"
                  alt="user-image"
                  class="mr-1"
                  height="12"
                />
              </a>

              <a
                href="javascript:void(0);"
                class="dropdown-item"
                @click="change_language('jp')"
              >
                <span class="align-middle" style="line-height: 200%"
                  >日本語</span
                >
                <img
                  :src="'../assets/images/flags/japan.jpg'"
                  alt="user-image"
                  class="mr-1"
                  height="12"
                />
              </a>
            </div>
          </li>
        </ul>
        <b-link
          class="ht-btn ht-btn--outline hire-btn"
          style="margin-right: 10px"
          :href="login_url"
          >{{ lan.key1[cur_lan] }}</b-link
        >
      </b-btn-group>
      <b-collapse
        class="default-nav justify-content-center"
        is-nav
        id="nav_collapse"
      >
        <b-navbar-nav class="navbar-nav main-menu" v-if="isTarget">
          <b-nav-item href="#home" class="scroll"
            ><span>{{ lan.key2[cur_lan] }}</span></b-nav-item
          >
          <b-nav-item href="#about" class="scroll"
            ><span>{{ lan.key3[cur_lan] }}</span></b-nav-item
          >
          <b-nav-item href="#requirement" class="scroll"
            ><span>{{ lan.key4[cur_lan] }}</span></b-nav-item
          >
          <b-nav-item href="#feature" class="scroll"
            ><span>{{ lan.key5[cur_lan] }}</span></b-nav-item
          >
          <b-nav-item href="#pricing" class="scroll"
            ><span>{{ lan.key6[cur_lan] }}</span></b-nav-item
          >
          <b-nav-item to="/faq" href="#faq" class="scroll">{{
            lan.key7[cur_lan]
          }}</b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="navbar-nav main-menu" v-if="!isTarget">
          <b-nav-item to="/" href="#home" class="scroll"
            ><span>{{ lan.key2[cur_lan] }}</span></b-nav-item
          >
          <b-nav-item to="/" href="#about" class="scroll"
            ><span>{{ lan.key3[cur_lan] }}</span></b-nav-item
          >
          <b-nav-item to="/" href="#requirement" class="scroll"
            ><span>{{ lan.key4[cur_lan] }}</span></b-nav-item
          >
          <b-nav-item to="/" href="#feature" class="scroll"
            ><span>{{ lan.key5[cur_lan] }}</span></b-nav-item
          >
          <b-nav-item to="/" href="#pricing" class="scroll"
            ><span>{{ lan.key6[cur_lan] }}</span></b-nav-item
          >
          <b-nav-item to="/faq" href="#faq" class="scroll">{{
            lan.key7[cur_lan]
          }}</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      load: false,
      limitPosition: 200,
      scrolled: false,
      showlan: 0,
      lastPosition: 500,
      cur_lan: localStorage.getItem("cur_lan") || "jp",
      lan: JSON.parse(localStorage.getItem("creis_web_language_data")).data,
      login_url:'',
    };
  },
  props: {
    isTarget: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    let partform=location.href.indexOf('stage.creis.jp')>-1?'stage':'live';
    this.login_url='https://auth.creis.jp/login?language='+this.cur_lan+'&partform='+partform;
    (function () {
      scrollTo();
    })();

    function scrollTo() {
      const links = document.querySelectorAll(".scroll > a");
      links.forEach((each) => (each.onclick = scrollAnchors));
    }

    function scrollAnchors(e, respond = null) {
      const distanceToTop = (el) => Math.floor(el.getBoundingClientRect().top);
      e.preventDefault();
      var targetID = respond
        ? respond.getAttribute("href")
        : this.getAttribute("href");
      const targetAnchor = document.querySelector(targetID);
      if (!targetAnchor) return;
      const originalTop = distanceToTop(targetAnchor);
      window.scrollBy({ top: originalTop, left: 0, behavior: "smooth" });
      const checkIfDone = setInterval(function () {
        const atBottom =
          window.innerHeight + window.pageYOffset >=
          document.body.offsetHeight - 190;
        if (distanceToTop(targetAnchor) === 0 || atBottom) {
          targetAnchor.tabIndex = "-1";
          targetAnchor.focus();
          clearInterval(checkIfDone);
        }
      }, 800);
    }
    
  },
  methods: {
    // sticky menu script
    handleScroll() {
      if (
        this.lastPosition < window.scrollY &&
        this.limitPosition < window.scrollY
      ) {
        this.scrolled = true;
        // move up!
      }
      if (this.lastPosition > window.scrollY) {
        this.scrolled = true;
        // move down
      }
      this.lastPosition = window.scrollY;
      this.scrolled = window.scrollY > 50;
    },

    // offcanvas searchbox
    toggleClass(addRemoveClass, className) {
      const el = document.querySelector("#search-overlay");
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    change_language(lan) {
      this.cur_lan = lan;
      this.showlan = 0;
      localStorage.setItem("cur_lan", lan);
      // TODO CX issue here.
      // var originalUrl = window.location.href,
      // toUrl = originalUrl.indexOf("#") != -1 && originalUrl.split("#")[1],
      // reg = /^[\w\?&=\/]*$/;
      // if (toUrl && reg.test(toUrl)) {
      //   window.location.href = toUrl;
      // }
      window.location.reload();
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss">
.dropdown {
  .dropdown-menu {
    display: block;
  }
  a {
    background: none;
    margin-right: 10px;
    margin-top: 5px;
  }
}
</style>